import getUserNotificationPreferences from "./getUserNotificationPreferences";
import userprofilenotifications from "./userprofilenotifications";
const notificationsProfilePreferences = {
  getUserNotificationPreferences,
  userprofilenotifications,
};

export default notificationsProfilePreferences;
